import { FormattedMessage } from "react-intl";
import { EcgLeads } from "../../../api/index.defs";
import scaleIcon from "../../../assets/ecg-graph/scale.svg";
import closeIcon from "../../../assets/shared/close.svg";
import { useEcgsTableContext } from "../../../context/EcgsTableContext";
import useResponsive from "../../../hooks/useResponsive";
import { Button, Modal } from "@shltelemedicine/shl-ui-lib";
import EcgDateTime from "../../Shared/EcgDateTime/EcgDateTime";
import EcgTransform from "../EcgTransform/EcgTransform";
import styles from "./EcgGraphModal.module.css";
type EcgGraphModalProps = {
  show?: boolean;
  date?: string;
  graph?: EcgLeads;
  onClose?: () => void;
};

const EcgGraphModal = ({ show, date, graph, onClose }: EcgGraphModalProps) => {
  const {
    isMobile,
    isTabletPortrait,
    isModalMobileLandscape,
  } = useResponsive();

  const {
    state: { selectedEcg },
  } = useEcgsTableContext();

  const showOnMobile = isModalMobileLandscape && selectedEcg;

  return (
    <Modal
      centered
      backdrop="static"
      show={!!showOnMobile || show}
      onHide={onClose}
      dialogClassName={`${!isMobile && !showOnMobile && styles.dialog}
      ${!isMobile &&
        !showOnMobile &&
        isTabletPortrait &&
        styles.dialogTabletPortrait}
        ${styles.dialogStretch} 
        ${showOnMobile && styles.dialogModalMobileLandscape} `}
      contentClassName={`${
        showOnMobile ? "prim-bg-gradient-color" : ""
      } ${!isTabletPortrait && "h-100"}`}
      header={
        !isMobile && !showOnMobile ? (
          <h5 className="mb-0">
            <EcgDateTime date={date} showTime />
          </h5>
        ) : (
          undefined
        )
      }
      footer={
        !isMobile && !showOnMobile ? (
          <div className="d-flex justify-content-between align-items-end">
            <div className={styles.scaleWrapper}>
              <img src={scaleIcon} alt="" className="img-fluid" />
            </div>
            <Button
              icon={{ src: closeIcon, width: 18, height: 18 }}
              bgColor="transparent linear-gradient(180deg, #505F95 0%, #2C449A 100%) 0% 0% no-repeat padding-box"
              onClick={onClose}
            >
              <FormattedMessage id="GLOBAL.CLOSE" defaultMessage="Close" />
            </Button>
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <FormattedMessage
              id="ECG_MODAL.ROTATE"
              defaultMessage="Rotate your device to edit the ECG"
            />
          </div>
        )
      }
    >
      <div className={`${styles.dialogContent} h-100 px-sm-2`}>
        {graph && <EcgTransform graph={graph} />}
      </div>
    </Modal>
  );
};

export default EcgGraphModal;
